import { Skeleton } from 'components/Skeleton/Skeleton'
import { ReactComponent as RightArrow } from 'assets/icons/blockyRightArrow16.svg'
import cx from 'classnames'
import { Button } from 'components/Button/Button'
import { ButtonLink } from 'components/Button/ButtonLink'
import { useRequestReadAccess } from 'hooks/queries/articles/useRequestReadAccess'
import Styles from '../CardViewComponent.module.scss'
import { CardViewProps, SkeletonCardProps } from '../cardViewTypes'
import { getDetailsFromBackground } from '../utils/getDetailsFromBackground'
import { buttonLinkText } from '../utils/textUtils'
import { InteractionButtons } from './components/InteractionButtons'

export const ExpandedCardView = (props: CardViewProps) => {
  const {
    disabled,
    selected,
    commentSelected,
    tasks,
    comments,
    mentionSubject,
    mentionType,
    subtitle,
    url,
    cardStyle,
    articleId,
    loading,
    isError,
  } = props
  const { font, background } = cardStyle
  const details = getDetailsFromBackground(background)
  const [requestReadAccess, requestingAccess] = useRequestReadAccess()
  const backgroundColor = isError ? 'linear-gradient(90deg, #EBF0F7 0%, #DCE4F0 100%)' : details.background

  if (loading) return <ExpandedCardSkeleton selected={selected} />

  const viewButton = () => {
    if (isError && articleId)
      return (
        <Button
          className={Styles.openLink}
          isDisabled={requestingAccess}
          variant="secondary"
          endIcon={RightArrow}
          onPress={() => requestReadAccess(articleId)}
        >
          Request Access
        </Button>
      )
    return (
      <ButtonLink
        className={Styles.openLink}
        disabled={disabled}
        to={url}
        variant={details.darkBackground ? 'ghostWhite' : 'tertiary'}
        endIcon={RightArrow}
        target="_blank"
      >
        {buttonLinkText(mentionType)}
      </ButtonLink>
    )
  }

  return (
    <div
      data-test-id="cardViewComponent"
      style={{ background: backgroundColor }}
      className={`${cx(Styles.cardView, Styles.expanded, {
        [Styles.selected]: selected,
        [Styles.commentSelected]: commentSelected,
        [Styles.restricted]: isError,
        [Styles.boxShadow]: details.includeBoxShadow && !isError,
        [Styles.whiteText]: details.darkBackground && !isError,
      })}`}
    >
      <div className={Styles.titleContainer}>
        <p className={Styles.title} style={{ fontFamily: font }}>
          {mentionSubject.title}
        </p>
        <p className={Styles.subtitle} style={{ fontFamily: font }}>
          {subtitle}
        </p>
        {viewButton()}
      </div>
      <InteractionButtons disabled={disabled} tasks={tasks} comments={comments} />
    </div>
  )
}

const ExpandedCardSkeleton = ({ selected }: SkeletonCardProps) => {
  return (
    <div
      data-test-id="cardViewComponent"
      className={`${cx(Styles.cardView, Styles.expanded, Styles.loading, {
        [Styles.selected]: selected,
      })}`}
    >
      <div className={Styles.titleContainer}>
        <Skeleton className={Styles.title} paragraph={false} title={false} />
        <Skeleton className={Styles.subtitle} paragraph={false} title={false} />
        <Skeleton className={Styles.buttonSkeleton} paragraph={false} title={false} />
      </div>
    </div>
  )
}
